export default __webpack_public_path__ + "static/media/38-39.f8116d0c.png";